<template>
  <div class="social-chunk" v-on:click="goUrl">
    <social-badge :name="name" :url="linkUrl" large brown :sel="sel" />
    <div class="wear">{{ $nippets.home.weareillx }}</div>
    <div class="followers" v-html="counts[name]"></div>
    <a class="hiddenlink" ref="hlink" target="_blank" :href="linkUrl"></a>
  </div>
</template>

<script>
import SocialBadge from '@/components/buttons/SocialBadge.vue'

export default {
  components: {
    SocialBadge
  },
  props: {
    name: String
  },
  data () {
    return {
      sel: false,
      counts: {}
    }
  },
  mounted() {
    this.$el.addEventListener('mouseenter', this.setSel)
    this.$el.addEventListener('mouseleave', this.unsetSel)
  },
  beforeDestroy() {
    this.$el.removeEventListener('mouseenter', this.setSel)
    this.$el.removeEventListener('mouseleave', this.unsetSel)
  },
  computed: {
    linkUrl: function () {
      return this.$nippets.social[this.name].link
    },
    count: function () {
      return this.$nippets.social[this.name].count
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData() {
      let social = await(this.$store.dispatch('fetchSetting', 'social'))
      this.counts = social.counts
    },
    goUrl () {
      this.$refs.hlink.click()
    },
    setSel() {
      this.sel = true
    },
    unsetSel () {
      this.sel = false
    }
  }
}
</script>

<style scoped>

.social-chunk{
  cursor:pointer;
}

.wear{
  color:#6d6d64;
  text-transform: uppercase;
  font-size:13px;
}
.social-chunk:hover .wear{
  color:#ce0e2d;
}

.social-chunk:hover .followers{
  color:#ce0e2d;
}

.hiddenLink{
  display:none;
}

</style>